/**
 * Chinese profanity data
 * Auto-generated from JSON files - DO NOT EDIT MANUALLY
 *
 * Language: Chinese
 * Version: 1.0.0
 * Last Updated: 2025-09-30
 * Total Entries: 221
 */

export const ZH = {
  "metadata": {
    "name": "Chinese",
    "code": "zh",
    "version": "1.0.0",
    "lastUpdated": "2025-09-30",
    "wordCount": 221
  },
  "words": [
    {
      "word": "妈的",
      "severity": 2,
      "categories": [
        "general",
        "family_honor"
      ],
      "variations": [
        "md",
        "妈d",
        "马的",
        "🐴的"
      ],
      "case_sensitive": false,
      "context_notes": "Common mild expletive, literally 'mother's', often used for emphasis",
      "target_type": "general"
    },
    {
      "word": "操",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "cao",
        "草",
        "艹",
        "c",
        "靠"
      ],
      "case_sensitive": false,
      "context_notes": "Strong profanity meaning 'fuck', commonly used as intensifier",
      "target_type": "general"
    },
    {
      "word": "他妈的",
      "severity": 3,
      "categories": [
        "family_honor",
        "general"
      ],
      "variations": [
        "tmd",
        "他妈d",
        "他马的",
        "ta ma de"
      ],
      "case_sensitive": false,
      "context_notes": "Strong profanity attacking someone's mother, very offensive",
      "target_type": "individual"
    },
    {
      "word": "傻逼",
      "severity": 3,
      "categories": [
        "insult",
        "sexual"
      ],
      "variations": [
        "sb",
        "傻b",
        "煞笔",
        "沙比"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone a 'stupid cunt', combines intelligence and sexual insult",
      "target_type": "individual"
    },
    {
      "word": "草泥马",
      "severity": 4,
      "categories": [
        "family_honor",
        "sexual",
        "internet_memes"
      ],
      "variations": [
        "cnm",
        "草你妈",
        "艹你妈",
        "草ni马"
      ],
      "case_sensitive": false,
      "context_notes": "Internet meme euphemism for 'fuck your mother', sounds like alpaca (羊驼)",
      "target_type": "individual"
    },
    {
      "word": "白痴",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "bc",
        "白c",
        "baichi"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone an 'idiot' or 'moron', moderate insult",
      "target_type": "individual"
    },
    {
      "word": "笨蛋",
      "severity": 1,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "bendan",
        "笨d",
        "ben dan"
      ],
      "case_sensitive": false,
      "context_notes": "Mild insult meaning 'stupid egg' or 'dummy', often used playfully",
      "target_type": "individual"
    },
    {
      "word": "去死",
      "severity": 4,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "去si",
        "qusi",
        "去4"
      ],
      "case_sensitive": false,
      "context_notes": "Death threat meaning 'go die', extremely serious",
      "target_type": "individual"
    },
    {
      "word": "滚",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "gun",
        "滚开",
        "滚蛋"
      ],
      "case_sensitive": false,
      "context_notes": "Dismissive command meaning 'scram' or 'get lost'",
      "target_type": "individual"
    },
    {
      "word": "畜生",
      "severity": 3,
      "categories": [
        "animal_comparisons",
        "insult"
      ],
      "variations": [
        "chusheng",
        "畜s",
        "禽兽"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone a 'beast' or 'animal', dehumanizing insult",
      "target_type": "individual"
    },
    {
      "word": "婊子",
      "severity": 4,
      "categories": [
        "sexual",
        "hate_speech"
      ],
      "variations": [
        "bz",
        "婊z",
        "表子"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely derogatory term for women meaning 'whore' or 'bitch'",
      "target_type": "individual"
    },
    {
      "word": "屌",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "diao",
        "叼",
        "diao"
      ],
      "case_sensitive": false,
      "context_notes": "Male genitalia reference, also used as intensifier meaning 'awesome'",
      "target_type": "general"
    },
    {
      "word": "逼",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "bi",
        "B",
        "逼"
      ],
      "case_sensitive": false,
      "context_notes": "Female genitalia reference, very vulgar",
      "target_type": "general"
    },
    {
      "word": "狗屎",
      "severity": 2,
      "categories": [
        "scatological",
        "animal_comparisons"
      ],
      "variations": [
        "gou shi",
        "狗s",
        "dog shit"
      ],
      "case_sensitive": false,
      "context_notes": "Literally 'dog shit', used to describe something worthless",
      "target_type": "general"
    },
    {
      "word": "垃圾",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "laji",
        "lj",
        "垃j"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone/something 'trash' or 'garbage'",
      "target_type": "general"
    },
    {
      "word": "废物",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "fw",
        "废w",
        "fei wu"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone 'useless' or 'waste of space'",
      "target_type": "individual"
    },
    {
      "word": "小日本",
      "severity": 3,
      "categories": [
        "hate_speech",
        "nationality"
      ],
      "variations": [
        "xiao ri ben",
        "小鬼子",
        "日本鬼子"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for Japanese people, historically loaded",
      "target_type": "group"
    },
    {
      "word": "鬼子",
      "severity": 4,
      "categories": [
        "hate_speech",
        "nationality"
      ],
      "variations": [
        "guizi",
        "洋鬼子",
        "日本鬼子"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely derogatory term for foreigners, especially Japanese",
      "target_type": "group"
    },
    {
      "word": "洋鬼子",
      "severity": 3,
      "categories": [
        "hate_speech",
        "nationality"
      ],
      "variations": [
        "yang guizi",
        "洋人",
        "老外"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for Westerners, 'foreign devils'",
      "target_type": "group"
    },
    {
      "word": "死胖子",
      "severity": 2,
      "categories": [
        "insult",
        "appearance"
      ],
      "variations": [
        "si pang zi",
        "胖子",
        "死胖"
      ],
      "case_sensitive": false,
      "context_notes": "Body-shaming insult meaning 'fat pig' or 'fatty'",
      "target_type": "individual"
    },
    {
      "word": "丑八怪",
      "severity": 2,
      "categories": [
        "insult",
        "appearance"
      ],
      "variations": [
        "chou ba guai",
        "丑b怪",
        "丑怪"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone extremely ugly, appearance-based insult",
      "target_type": "individual"
    },
    {
      "word": "穷鬼",
      "severity": 2,
      "categories": [
        "insult",
        "class"
      ],
      "variations": [
        "qiong gui",
        "穷g",
        "qiong"
      ],
      "case_sensitive": false,
      "context_notes": "Class-based insult meaning 'poor ghost' or poverty-shaming",
      "target_type": "individual"
    },
    {
      "word": "暴发户",
      "severity": 2,
      "categories": [
        "insult",
        "class"
      ],
      "variations": [
        "bao fa hu",
        "bfh",
        "nouveau riche"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for nouveau riche, 'new money' criticism",
      "target_type": "individual"
    },
    {
      "word": "土包子",
      "severity": 2,
      "categories": [
        "insult",
        "class"
      ],
      "variations": [
        "tu bao zi",
        "土b子",
        "土包"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone unsophisticated or 'country bumpkin'",
      "target_type": "individual"
    },
    {
      "word": "神经病",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "shen jing bing",
        "sjb",
        "神经"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone 'mentally ill' or 'crazy', ableist language",
      "target_type": "individual"
    },
    {
      "word": "脑残",
      "severity": 2,
      "categories": [
        "insult",
        "hate_speech"
      ],
      "variations": [
        "nao can",
        "nc",
        "脑c"
      ],
      "case_sensitive": false,
      "context_notes": "Ableist slur meaning 'brain-damaged', highly inappropriate",
      "target_type": "individual"
    },
    {
      "word": "弱智",
      "severity": 3,
      "categories": [
        "hate_speech",
        "insult"
      ],
      "variations": [
        "ruo zhi",
        "rz",
        "弱z"
      ],
      "case_sensitive": false,
      "context_notes": "Ableist slur for intellectual disability, extremely inappropriate",
      "target_type": "individual"
    },
    {
      "word": "基佬",
      "severity": 3,
      "categories": [
        "hate_speech",
        "sexual"
      ],
      "variations": [
        "ji lao",
        "jl",
        "gay佬"
      ],
      "case_sensitive": false,
      "context_notes": "Homophobic slur for gay men, highly offensive",
      "target_type": "group"
    },
    {
      "word": "死gay",
      "severity": 3,
      "categories": [
        "hate_speech",
        "sexual"
      ],
      "variations": [
        "si gay",
        "死g",
        "sg"
      ],
      "case_sensitive": false,
      "context_notes": "Homophobic slur combining death wish with gay slur",
      "target_type": "individual"
    },
    {
      "word": "骚货",
      "severity": 4,
      "categories": [
        "sexual",
        "hate_speech"
      ],
      "variations": [
        "sao huo",
        "sh",
        "骚h"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely derogatory sexual term for women meaning 'slut'",
      "target_type": "individual"
    },
    {
      "word": "荡妇",
      "severity": 4,
      "categories": [
        "sexual",
        "hate_speech"
      ],
      "variations": [
        "dang fu",
        "df",
        "荡f"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely derogatory term meaning 'loose woman' or 'slut'",
      "target_type": "individual"
    },
    {
      "word": "臭婊子",
      "severity": 4,
      "categories": [
        "sexual",
        "hate_speech"
      ],
      "variations": [
        "chou biao zi",
        "cbz",
        "臭b子"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar and misogynistic term, 'stinking whore'",
      "target_type": "individual"
    },
    {
      "word": "王八蛋",
      "severity": 3,
      "categories": [
        "family_honor",
        "animal_comparisons"
      ],
      "variations": [
        "wang ba dan",
        "wbd",
        "王8蛋"
      ],
      "case_sensitive": false,
      "context_notes": "Traditional insult meaning 'turtle egg', implies illegitimate birth",
      "target_type": "individual"
    },
    {
      "word": "龟儿子",
      "severity": 3,
      "categories": [
        "family_honor",
        "animal_comparisons"
      ],
      "variations": [
        "gui er zi",
        "龟儿",
        "gez"
      ],
      "case_sensitive": false,
      "context_notes": "Sichuan dialect insult meaning 'turtle son', implies cuckoldry",
      "target_type": "individual"
    },
    {
      "word": "兔崽子",
      "severity": 2,
      "categories": [
        "animal_comparisons",
        "insult"
      ],
      "variations": [
        "tu zai zi",
        "兔z子",
        "tzz"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone a 'rabbit spawn', implies cowardice",
      "target_type": "individual"
    },
    {
      "word": "贱人",
      "severity": 3,
      "categories": [
        "insult",
        "class"
      ],
      "variations": [
        "jian ren",
        "jr",
        "贱r"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone 'lowly person' or 'cheap person', class-based insult",
      "target_type": "individual"
    },
    {
      "word": "贱货",
      "severity": 3,
      "categories": [
        "insult",
        "sexual"
      ],
      "variations": [
        "jian huo",
        "jh",
        "贱h"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term meaning 'cheap goods', often targeting women",
      "target_type": "individual"
    },
    {
      "word": "死变态",
      "severity": 3,
      "categories": [
        "insult",
        "sexual"
      ],
      "variations": [
        "si bian tai",
        "sbt",
        "死bt"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone a 'dead pervert' or sexual deviant",
      "target_type": "individual"
    },
    {
      "word": "色狼",
      "severity": 3,
      "categories": [
        "sexual",
        "insult"
      ],
      "variations": [
        "se lang",
        "sl",
        "色l"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone a 'sex wolf' or sexual predator",
      "target_type": "individual"
    },
    {
      "word": "流氓",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "liu mang",
        "lm",
        "流m"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone a 'hooligan' or 'scoundrel'",
      "target_type": "individual"
    },
    {
      "word": "混蛋",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "hun dan",
        "hd",
        "混d"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone a 'bastard' or 'scoundrel', moderate insult",
      "target_type": "individual"
    },
    {
      "word": "杂种",
      "severity": 3,
      "categories": [
        "family_honor",
        "insult"
      ],
      "variations": [
        "za zhong",
        "zz",
        "杂z"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone a 'bastard' or 'mongrel', attacks family legitimacy",
      "target_type": "individual"
    },
    {
      "word": "野种",
      "severity": 3,
      "categories": [
        "family_honor",
        "insult"
      ],
      "variations": [
        "ye zhong",
        "yz",
        "野z"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone 'wild seed', implies illegitimate birth",
      "target_type": "individual"
    },
    {
      "word": "狗杂种",
      "severity": 4,
      "categories": [
        "family_honor",
        "animal_comparisons"
      ],
      "variations": [
        "gou za zhong",
        "gzz",
        "狗zz"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive combining animal and illegitimacy insults",
      "target_type": "individual"
    },
    {
      "word": "人渣",
      "severity": 3,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "ren zha",
        "rz",
        "人z"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone 'human scum' or 'dregs of society'",
      "target_type": "individual"
    },
    {
      "word": "败类",
      "severity": 3,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "bai lei",
        "bl",
        "败l"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone 'scum' or 'degenerate', moral condemnation",
      "target_type": "individual"
    },
    {
      "word": "蠢猪",
      "severity": 2,
      "categories": [
        "animal_comparisons",
        "insult"
      ],
      "variations": [
        "chun zhu",
        "cz",
        "蠢z"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone a 'stupid pig', intelligence and character attack",
      "target_type": "individual"
    },
    {
      "word": "猪头",
      "severity": 1,
      "categories": [
        "animal_comparisons",
        "insult"
      ],
      "variations": [
        "zhu tou",
        "zt",
        "猪t"
      ],
      "case_sensitive": false,
      "context_notes": "Mild insult calling someone 'pig head', often used playfully",
      "target_type": "individual"
    },
    {
      "word": "猪脑子",
      "severity": 2,
      "categories": [
        "animal_comparisons",
        "insult"
      ],
      "variations": [
        "zhu nao zi",
        "znz",
        "猪nz"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone having a 'pig brain', intelligence attack",
      "target_type": "individual"
    },
    {
      "word": "狗东西",
      "severity": 3,
      "categories": [
        "animal_comparisons",
        "insult"
      ],
      "variations": [
        "gou dong xi",
        "gdx",
        "狗dx"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone a 'dog thing', dehumanizing insult",
      "target_type": "individual"
    },
    {
      "word": "走狗",
      "severity": 3,
      "categories": [
        "animal_comparisons",
        "political"
      ],
      "variations": [
        "zou gou",
        "zg",
        "走g"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone a 'running dog' or lackey, political insult",
      "target_type": "individual"
    },
    {
      "word": "卖国贼",
      "severity": 4,
      "categories": [
        "political",
        "hate_speech"
      ],
      "variations": [
        "mai guo zei",
        "mgz",
        "卖gz"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely serious accusation of being a 'traitor to the country'",
      "target_type": "individual"
    },
    {
      "word": "汉奸",
      "severity": 4,
      "categories": [
        "political",
        "hate_speech"
      ],
      "variations": [
        "han jian",
        "hj",
        "汉j"
      ],
      "case_sensitive": false,
      "context_notes": "Historical term for Chinese traitor, extremely serious accusation",
      "target_type": "individual"
    },
    {
      "word": "五毛",
      "severity": 2,
      "categories": [
        "political",
        "internet_memes"
      ],
      "variations": [
        "wu mao",
        "wm",
        "5毛"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for pro-government internet commenters",
      "target_type": "individual"
    },
    {
      "word": "自干五",
      "severity": 2,
      "categories": [
        "political",
        "internet_memes"
      ],
      "variations": [
        "zi gan wu",
        "zgw",
        "自g5"
      ],
      "case_sensitive": false,
      "context_notes": "Voluntary pro-government commenter, political internet slang",
      "target_type": "individual"
    },
    {
      "word": "艹",
      "severity": 3,
      "categories": [
        "sexual",
        "general",
        "internet_euphemism"
      ],
      "variations": [
        "cao",
        "草",
        "c"
      ],
      "case_sensitive": false,
      "context_notes": "Grass radical used to evade censorship for 操 (fuck)",
      "target_type": "general"
    },
    {
      "word": "变态",
      "severity": 3,
      "categories": [
        "insult",
        "sexual"
      ],
      "variations": [
        "bian tai",
        "bt",
        "变t"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone a 'pervert' or 'deviant'",
      "target_type": "individual"
    },
    {
      "word": "肏",
      "severity": 4,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "cao"
      ],
      "case_sensitive": false,
      "context_notes": "More explicit character for 'fuck' than 操",
      "target_type": "general"
    },
    {
      "word": "肏你妈",
      "severity": 4,
      "categories": [
        "sexual",
        "family_honor"
      ],
      "variations": [
        "cao ni ma",
        "cnm"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck your mother - explicit variant with rare character",
      "target_type": "individual"
    },
    {
      "word": "操你",
      "severity": 4,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "cao ni",
        "cn"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck you - direct sexual profanity",
      "target_type": "individual"
    },
    {
      "word": "操你妈",
      "severity": 4,
      "categories": [
        "sexual",
        "family_honor"
      ],
      "variations": [
        "cao ni ma",
        "cnm",
        "操nm"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck your mother - extremely offensive family honor attack",
      "target_type": "individual"
    },
    {
      "word": "蠢驴",
      "severity": 2,
      "categories": [
        "animal_comparisons",
        "insult"
      ],
      "variations": [
        "chun lv",
        "cl"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone a 'stupid donkey'",
      "target_type": "individual"
    },
    {
      "word": "二百五",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "er bai wu",
        "250",
        "2b5"
      ],
      "case_sensitive": false,
      "context_notes": "Idiom for 'stupid' or 'good for nothing', literally '250'",
      "target_type": "individual"
    },
    {
      "word": "二逼",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "er bi",
        "2b",
        "二b"
      ],
      "case_sensitive": false,
      "context_notes": "Dumb cunt - combines stupidity and vulgarity",
      "target_type": "individual"
    },
    {
      "word": "肥猪",
      "severity": 2,
      "categories": [
        "animal_comparisons",
        "appearance"
      ],
      "variations": [
        "fei zhu",
        "fz",
        "肥z"
      ],
      "case_sensitive": false,
      "context_notes": "Fat pig - body-shaming insult",
      "target_type": "individual"
    },
    {
      "word": "干",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "gan"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck - Taiwan variant, traditional character distinguishes from 'dry'",
      "target_type": "general"
    },
    {
      "word": "干你娘",
      "severity": 4,
      "categories": [
        "sexual",
        "family_honor"
      ],
      "variations": [
        "gan ni niang",
        "gnn"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck your mother - Taiwan/Hokkien variant",
      "target_type": "individual"
    },
    {
      "word": "干你老母",
      "severity": 4,
      "categories": [
        "sexual",
        "family_honor"
      ],
      "variations": [
        "gan ni lao mu",
        "gnlm"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck your mother - extremely offensive variant",
      "target_type": "individual"
    },
    {
      "word": "滚蛋",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "gun dan",
        "gd",
        "滚d"
      ],
      "case_sensitive": false,
      "context_notes": "Piss off - literally 'rolling egg'",
      "target_type": "individual"
    },
    {
      "word": "龟孙子",
      "severity": 3,
      "categories": [
        "family_honor",
        "animal_comparisons"
      ],
      "variations": [
        "gui sun zi",
        "gsz"
      ],
      "case_sensitive": false,
      "context_notes": "Turtle grandson - family honor attack",
      "target_type": "individual"
    },
    {
      "word": "坏蛋",
      "severity": 1,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "huai dan",
        "hd",
        "坏d"
      ],
      "case_sensitive": false,
      "context_notes": "Bad egg - mild insult",
      "target_type": "individual"
    },
    {
      "word": "河蟹",
      "severity": 1,
      "categories": [
        "internet_memes",
        "political"
      ],
      "variations": [
        "he xie",
        "hx"
      ],
      "case_sensitive": false,
      "context_notes": "River crab - homophone for 和谐 (harmony), refers to censorship",
      "target_type": "general"
    },
    {
      "word": "鸡巴",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "ji ba",
        "jb",
        "鸡b"
      ],
      "case_sensitive": false,
      "context_notes": "Male genitalia - very vulgar",
      "target_type": "general"
    },
    {
      "word": "几巴",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "ji ba",
        "jb"
      ],
      "case_sensitive": false,
      "context_notes": "Male genitalia - variant spelling of 鸡巴",
      "target_type": "general"
    },
    {
      "word": "贱女人",
      "severity": 3,
      "categories": [
        "insult",
        "hate_speech"
      ],
      "variations": [
        "jian nv ren",
        "jnr",
        "贱nr"
      ],
      "case_sensitive": false,
      "context_notes": "Bitch - literally 'cheap woman', misogynistic",
      "target_type": "individual"
    },
    {
      "word": "靠",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "kao",
        "k"
      ],
      "case_sensitive": false,
      "context_notes": "Damn - euphemism for 操",
      "target_type": "general"
    },
    {
      "word": "靠北",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "kao bei",
        "kb"
      ],
      "case_sensitive": false,
      "context_notes": "Damn - Taiwan/Hokkien expression",
      "target_type": "general"
    },
    {
      "word": "烂货",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "lan huo",
        "lh",
        "烂h"
      ],
      "case_sensitive": false,
      "context_notes": "Rotten goods - worthless person",
      "target_type": "individual"
    },
    {
      "word": "老不死",
      "severity": 3,
      "categories": [
        "insult",
        "age"
      ],
      "variations": [
        "lao bu si",
        "lbs"
      ],
      "case_sensitive": false,
      "context_notes": "Old fart who won't die - ageist insult",
      "target_type": "individual"
    },
    {
      "word": "妈逼",
      "severity": 4,
      "categories": [
        "sexual",
        "family_honor"
      ],
      "variations": [
        "ma bi",
        "mb",
        "妈b"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar mother-related profanity",
      "target_type": "individual"
    },
    {
      "word": "你妈",
      "severity": 3,
      "categories": [
        "family_honor"
      ],
      "variations": [
        "ni ma",
        "nm",
        "你m"
      ],
      "case_sensitive": false,
      "context_notes": "Your mother - offensive family attack",
      "target_type": "individual"
    },
    {
      "word": "你妈的",
      "severity": 3,
      "categories": [
        "family_honor",
        "general"
      ],
      "variations": [
        "ni ma de",
        "nmd",
        "你md"
      ],
      "case_sensitive": false,
      "context_notes": "Your mother's - family honor attack",
      "target_type": "individual"
    },
    {
      "word": "你娘",
      "severity": 3,
      "categories": [
        "family_honor"
      ],
      "variations": [
        "ni niang",
        "nn"
      ],
      "case_sensitive": false,
      "context_notes": "Your mother - offensive variant",
      "target_type": "individual"
    },
    {
      "word": "你大爷",
      "severity": 2,
      "categories": [
        "family_honor",
        "general"
      ],
      "variations": [
        "ni da ye",
        "ndy"
      ],
      "case_sensitive": false,
      "context_notes": "Your uncle - Beijing dialect curse",
      "target_type": "individual"
    },
    {
      "word": "尿",
      "severity": 1,
      "categories": [
        "scatological"
      ],
      "variations": [
        "niao"
      ],
      "case_sensitive": false,
      "context_notes": "Piss - mild scatological term",
      "target_type": "general"
    },
    {
      "word": "拍马屁",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "pai ma pi",
        "pmp"
      ],
      "case_sensitive": false,
      "context_notes": "Brown-noser - literally 'pat horse butt'",
      "target_type": "individual"
    },
    {
      "word": "屁",
      "severity": 1,
      "categories": [
        "scatological"
      ],
      "variations": [
        "pi",
        "p"
      ],
      "case_sensitive": false,
      "context_notes": "Fart - mild scatological term",
      "target_type": "general"
    },
    {
      "word": "屁话",
      "severity": 2,
      "categories": [
        "general",
        "scatological"
      ],
      "variations": [
        "pi hua",
        "ph",
        "屁h"
      ],
      "case_sensitive": false,
      "context_notes": "Bullshit - literally 'fart talk'",
      "target_type": "general"
    },
    {
      "word": "禽兽",
      "severity": 3,
      "categories": [
        "animal_comparisons",
        "insult"
      ],
      "variations": [
        "qin shou",
        "qs"
      ],
      "case_sensitive": false,
      "context_notes": "Beast - dehumanizing insult",
      "target_type": "individual"
    },
    {
      "word": "三级片",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "san ji pian",
        "sjp",
        "3级片"
      ],
      "case_sensitive": false,
      "context_notes": "Category III film - pornographic movie",
      "target_type": "general"
    },
    {
      "word": "骚",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "sao",
        "s"
      ],
      "case_sensitive": false,
      "context_notes": "Slutty or horny - sexual insult",
      "target_type": "individual"
    },
    {
      "word": "骚逼",
      "severity": 4,
      "categories": [
        "sexual",
        "hate_speech"
      ],
      "variations": [
        "sao bi",
        "sb",
        "骚b"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar sexual slur for women",
      "target_type": "individual"
    },
    {
      "word": "傻屄",
      "severity": 3,
      "categories": [
        "insult",
        "sexual"
      ],
      "variations": [
        "sha bi",
        "sb"
      ],
      "case_sensitive": false,
      "context_notes": "Variant spelling of 傻逼 (stupid cunt)",
      "target_type": "individual"
    },
    {
      "word": "傻帽儿",
      "severity": 1,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "sha mao er",
        "sme"
      ],
      "case_sensitive": false,
      "context_notes": "Fool - mild insult",
      "target_type": "individual"
    },
    {
      "word": "傻缺",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "sha que",
        "sq",
        "傻q"
      ],
      "case_sensitive": false,
      "context_notes": "Fool or idiot",
      "target_type": "individual"
    },
    {
      "word": "煞笔",
      "severity": 3,
      "categories": [
        "insult",
        "sexual"
      ],
      "variations": [
        "sha bi",
        "sb"
      ],
      "case_sensitive": false,
      "context_notes": "Euphemistic spelling of 傻逼 (stupid cunt)",
      "target_type": "individual"
    },
    {
      "word": "屎",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "shi",
        "s"
      ],
      "case_sensitive": false,
      "context_notes": "Shit - scatological term",
      "target_type": "general"
    },
    {
      "word": "死人",
      "severity": 2,
      "categories": [
        "violence",
        "general"
      ],
      "variations": [
        "si ren",
        "sr"
      ],
      "case_sensitive": false,
      "context_notes": "Dead person - curse",
      "target_type": "individual"
    },
    {
      "word": "孙子",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "sun zi",
        "sz",
        "孙z"
      ],
      "case_sensitive": false,
      "context_notes": "Grandson - used as insult implying submission",
      "target_type": "individual"
    },
    {
      "word": "他奶奶的",
      "severity": 2,
      "categories": [
        "family_honor",
        "general"
      ],
      "variations": [
        "ta nai nai de",
        "tnnd"
      ],
      "case_sensitive": false,
      "context_notes": "His grandmother's - euphemistic curse",
      "target_type": "individual"
    },
    {
      "word": "王八",
      "severity": 2,
      "categories": [
        "animal_comparisons",
        "family_honor"
      ],
      "variations": [
        "wang ba",
        "wb",
        "王8"
      ],
      "case_sensitive": false,
      "context_notes": "Turtle - implies cuckoldry",
      "target_type": "individual"
    },
    {
      "word": "忘八蛋",
      "severity": 3,
      "categories": [
        "family_honor",
        "insult"
      ],
      "variations": [
        "wang ba dan",
        "wbd"
      ],
      "case_sensitive": false,
      "context_notes": "Variant of 王八蛋 (turtle egg)",
      "target_type": "individual"
    },
    {
      "word": "我操",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "wo cao",
        "wc",
        "我c"
      ],
      "case_sensitive": false,
      "context_notes": "Holy fuck - expression of shock",
      "target_type": "general"
    },
    {
      "word": "我靠",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "wo kao",
        "wk",
        "我k"
      ],
      "case_sensitive": false,
      "context_notes": "Damn - euphemism for 我操",
      "target_type": "general"
    },
    {
      "word": "无耻",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "wu chi",
        "wc"
      ],
      "case_sensitive": false,
      "context_notes": "Shameless - moral condemnation",
      "target_type": "individual"
    },
    {
      "word": "下贱",
      "severity": 3,
      "categories": [
        "insult",
        "class"
      ],
      "variations": [
        "xia jian",
        "xj",
        "下j"
      ],
      "case_sensitive": false,
      "context_notes": "Lowly or base - class insult",
      "target_type": "individual"
    },
    {
      "word": "小婊子",
      "severity": 4,
      "categories": [
        "sexual",
        "hate_speech"
      ],
      "variations": [
        "xiao biao zi",
        "xbz"
      ],
      "case_sensitive": false,
      "context_notes": "Little whore - extremely misogynistic",
      "target_type": "individual"
    },
    {
      "word": "小鬼子",
      "severity": 4,
      "categories": [
        "hate_speech",
        "nationality"
      ],
      "variations": [
        "xiao gui zi",
        "xgz"
      ],
      "case_sensitive": false,
      "context_notes": "Little devils - derogatory for Japanese (variant of 鬼子)",
      "target_type": "group"
    },
    {
      "word": "下三烂",
      "severity": 3,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "xia san lan",
        "xsl"
      ],
      "case_sensitive": false,
      "context_notes": "Lowlife - extremely lowly person",
      "target_type": "individual"
    },
    {
      "word": "一边去",
      "severity": 1,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "yi bian qu",
        "ybq"
      ],
      "case_sensitive": false,
      "context_notes": "Get lost - mild dismissal",
      "target_type": "individual"
    },
    {
      "word": "阴道",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "yin dao",
        "yd"
      ],
      "case_sensitive": false,
      "context_notes": "Vagina - clinical but can be vulgar in context",
      "target_type": "general"
    },
    {
      "word": "找死",
      "severity": 3,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "zhao si",
        "zs",
        "找s"
      ],
      "case_sensitive": false,
      "context_notes": "Seeking death - threatening phrase",
      "target_type": "individual"
    },
    {
      "word": "猪",
      "severity": 2,
      "categories": [
        "animal_comparisons"
      ],
      "variations": [
        "zhu",
        "z"
      ],
      "case_sensitive": false,
      "context_notes": "Pig - animal insult",
      "target_type": "individual"
    },
    {
      "word": "装逼",
      "severity": 2,
      "categories": [
        "insult",
        "sexual"
      ],
      "variations": [
        "zhuang bi",
        "zb",
        "装b"
      ],
      "case_sensitive": false,
      "context_notes": "Show off - literally 'pretending to be a cunt'",
      "target_type": "individual"
    },
    {
      "word": "屌你老母",
      "severity": 4,
      "categories": [
        "sexual",
        "family_honor"
      ],
      "variations": [
        "diu nei lou mou"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck your mother - extremely offensive in Cantonese (diu2 nei5 lou5 mou5)",
      "target_type": "individual"
    },
    {
      "word": "撚",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "lan"
      ],
      "case_sensitive": false,
      "context_notes": "Male genitalia - Cantonese vulgar term (lan2)",
      "target_type": "general"
    },
    {
      "word": "閪",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "gat"
      ],
      "case_sensitive": false,
      "context_notes": "Female genitalia - Cantonese vulgar term (gat1)",
      "target_type": "general"
    },
    {
      "word": "柒",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "chat"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot - Cantonese insult (chat1)",
      "target_type": "individual"
    },
    {
      "word": "仆街",
      "severity": 3,
      "categories": [
        "violence",
        "insult"
      ],
      "variations": [
        "puk gaai"
      ],
      "case_sensitive": false,
      "context_notes": "Fall on the street and die - Cantonese curse (puk1 gaai1)",
      "target_type": "individual"
    },
    {
      "word": "冚家铲",
      "severity": 4,
      "categories": [
        "family_honor"
      ],
      "variations": [
        "ham gaa caan"
      ],
      "case_sensitive": false,
      "context_notes": "Curse on your whole family - extremely offensive Cantonese (ham6 gaa1 caan2)",
      "target_type": "individual"
    },
    {
      "word": "咸家铲",
      "severity": 4,
      "categories": [
        "family_honor"
      ],
      "variations": [
        "haam gaa caan"
      ],
      "case_sensitive": false,
      "context_notes": "Variant of 冚家鏟 - curse on family (haam4 gaa1 caan2)",
      "target_type": "individual"
    },
    {
      "word": "西",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "sai"
      ],
      "case_sensitive": false,
      "context_notes": "Cantonese mild profanity (sai1)",
      "target_type": "general"
    },
    {
      "word": "食屎",
      "severity": 3,
      "categories": [
        "scatological"
      ],
      "variations": [
        "sik si"
      ],
      "case_sensitive": false,
      "context_notes": "Eat shit - Cantonese insult (sik6 si2)",
      "target_type": "individual"
    },
    {
      "word": "死开",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "sei hoi"
      ],
      "case_sensitive": false,
      "context_notes": "Piss off - Cantonese dismissal (sei2 hoi1)",
      "target_type": "individual"
    },
    {
      "word": "鸡",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "ji",
        "j"
      ],
      "case_sensitive": false,
      "context_notes": "Prostitute - literally 'chicken'",
      "target_type": "individual"
    },
    {
      "word": "妓女",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "ji nv",
        "jn"
      ],
      "case_sensitive": false,
      "context_notes": "Prostitute - formal term",
      "target_type": "individual"
    },
    {
      "word": "嫖客",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "piao ke",
        "pk"
      ],
      "case_sensitive": false,
      "context_notes": "John or prostitute client",
      "target_type": "individual"
    },
    {
      "word": "卖淫",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "mai yin",
        "my"
      ],
      "case_sensitive": false,
      "context_notes": "Prostitution - selling sex",
      "target_type": "general"
    },
    {
      "word": "做爱",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "zuo ai",
        "za"
      ],
      "case_sensitive": false,
      "context_notes": "Make love or have sex",
      "target_type": "general"
    },
    {
      "word": "性交",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "xing jiao",
        "xj"
      ],
      "case_sensitive": false,
      "context_notes": "Sexual intercourse - clinical term",
      "target_type": "general"
    },
    {
      "word": "口交",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "kou jiao",
        "kj"
      ],
      "case_sensitive": false,
      "context_notes": "Oral sex",
      "target_type": "general"
    },
    {
      "word": "肛交",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "gang jiao",
        "gj"
      ],
      "case_sensitive": false,
      "context_notes": "Anal sex",
      "target_type": "general"
    },
    {
      "word": "吹箫",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "chui xiao",
        "cx"
      ],
      "case_sensitive": false,
      "context_notes": "Blow job - literally 'blow flute'",
      "target_type": "general"
    },
    {
      "word": "手淫",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "shou yin",
        "sy"
      ],
      "case_sensitive": false,
      "context_notes": "Masturbation",
      "target_type": "general"
    },
    {
      "word": "淫",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "yin",
        "y"
      ],
      "case_sensitive": false,
      "context_notes": "Lewd or lustful",
      "target_type": "general"
    },
    {
      "word": "淫荡",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "yin dang",
        "yd"
      ],
      "case_sensitive": false,
      "context_notes": "Lascivious or lewd",
      "target_type": "individual"
    },
    {
      "word": "色情",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "se qing",
        "sq"
      ],
      "case_sensitive": false,
      "context_notes": "Pornography or erotic",
      "target_type": "general"
    },
    {
      "word": "强奸",
      "severity": 4,
      "categories": [
        "sexual",
        "violence"
      ],
      "variations": [
        "qiang jian",
        "qj"
      ],
      "case_sensitive": false,
      "context_notes": "Rape - extremely serious",
      "target_type": "general"
    },
    {
      "word": "奸",
      "severity": 4,
      "categories": [
        "sexual",
        "violence"
      ],
      "variations": [
        "jian",
        "j"
      ],
      "case_sensitive": false,
      "context_notes": "Rape - shorter form",
      "target_type": "general"
    },
    {
      "word": "乳",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [
        "ru",
        "r"
      ],
      "case_sensitive": false,
      "context_notes": "Breast - can be vulgar in context",
      "target_type": "general"
    },
    {
      "word": "乳房",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [
        "ru fang",
        "rf"
      ],
      "case_sensitive": false,
      "context_notes": "Breasts - clinical",
      "target_type": "general"
    },
    {
      "word": "乳头",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "ru tou",
        "rt"
      ],
      "case_sensitive": false,
      "context_notes": "Nipple",
      "target_type": "general"
    },
    {
      "word": "屁股",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "pi gu",
        "pg"
      ],
      "case_sensitive": false,
      "context_notes": "Butt or buttocks - mild",
      "target_type": "general"
    },
    {
      "word": "肛门",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "gang men",
        "gm"
      ],
      "case_sensitive": false,
      "context_notes": "Anus",
      "target_type": "general"
    },
    {
      "word": "阴茎",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "yin jing",
        "yj"
      ],
      "case_sensitive": false,
      "context_notes": "Penis - clinical",
      "target_type": "general"
    },
    {
      "word": "睾丸",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "gao wan",
        "gw"
      ],
      "case_sensitive": false,
      "context_notes": "Testicles - clinical",
      "target_type": "general"
    },
    {
      "word": "蛋",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "dan",
        "d"
      ],
      "case_sensitive": false,
      "context_notes": "Balls - slang for testicles",
      "target_type": "general"
    },
    {
      "word": "精液",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "jing ye",
        "jy"
      ],
      "case_sensitive": false,
      "context_notes": "Semen",
      "target_type": "general"
    },
    {
      "word": "nmsl",
      "severity": 4,
      "categories": [
        "family_honor",
        "violence"
      ],
      "variations": [
        "你妈死了"
      ],
      "case_sensitive": false,
      "context_notes": "Your mother is dead - extremely offensive internet abbreviation",
      "target_type": "individual"
    },
    {
      "word": "wsnd",
      "severity": 3,
      "categories": [
        "family_honor"
      ],
      "variations": [
        "我是你爹"
      ],
      "case_sensitive": false,
      "context_notes": "I'm your father - insulting superiority",
      "target_type": "individual"
    },
    {
      "word": "mmp",
      "severity": 3,
      "categories": [
        "general"
      ],
      "variations": [
        "妈卖批"
      ],
      "case_sensitive": false,
      "context_notes": "Euphemism for 妈的逼 (mother's cunt)",
      "target_type": "general"
    },
    {
      "word": "wc",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "卧槽"
      ],
      "case_sensitive": false,
      "context_notes": "Holy shit - euphemism for 我操",
      "target_type": "general"
    },
    {
      "word": "卧槽",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "wo cao",
        "wc"
      ],
      "case_sensitive": false,
      "context_notes": "Holy shit - literally 'lying trough', euphemism",
      "target_type": "general"
    },
    {
      "word": "妈卖批",
      "severity": 3,
      "categories": [
        "general"
      ],
      "variations": [
        "ma mai pi",
        "mmp"
      ],
      "case_sensitive": false,
      "context_notes": "Euphemism for vulgar mother-related curse",
      "target_type": "general"
    },
    {
      "word": "马勒戈壁",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "ma le ge bi",
        "mlgb"
      ],
      "case_sensitive": false,
      "context_notes": "Euphemism for 妈了个逼 (mother's cunt)",
      "target_type": "general"
    },
    {
      "word": "我去",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "wo qu",
        "wq"
      ],
      "case_sensitive": false,
      "context_notes": "What the... - mild euphemism",
      "target_type": "general"
    },
    {
      "word": "狗娘养的",
      "severity": 4,
      "categories": [
        "family_honor",
        "animal_comparisons"
      ],
      "variations": [
        "gou niang yang de",
        "gnyd"
      ],
      "case_sensitive": false,
      "context_notes": "Raised by a dog mother - family honor attack",
      "target_type": "individual"
    },
    {
      "word": "畜类",
      "severity": 3,
      "categories": [
        "animal_comparisons"
      ],
      "variations": [
        "chu lei",
        "cl"
      ],
      "case_sensitive": false,
      "context_notes": "Animals - dehumanizing",
      "target_type": "group"
    },
    {
      "word": "狗腿子",
      "severity": 3,
      "categories": [
        "animal_comparisons",
        "political"
      ],
      "variations": [
        "gou tui zi",
        "gtz"
      ],
      "case_sensitive": false,
      "context_notes": "Dog's leg - lackey or henchman",
      "target_type": "individual"
    },
    {
      "word": "野狗",
      "severity": 2,
      "categories": [
        "animal_comparisons"
      ],
      "variations": [
        "ye gou",
        "yg"
      ],
      "case_sensitive": false,
      "context_notes": "Wild dog - insult",
      "target_type": "individual"
    },
    {
      "word": "癞蛤蟆",
      "severity": 2,
      "categories": [
        "animal_comparisons",
        "appearance"
      ],
      "variations": [
        "lai ha ma",
        "lhm"
      ],
      "case_sensitive": false,
      "context_notes": "Ugly toad - appearance insult",
      "target_type": "individual"
    },
    {
      "word": "丑女",
      "severity": 2,
      "categories": [
        "appearance",
        "hate_speech"
      ],
      "variations": [
        "chou nv",
        "cn"
      ],
      "case_sensitive": false,
      "context_notes": "Ugly woman",
      "target_type": "individual"
    },
    {
      "word": "秃子",
      "severity": 1,
      "categories": [
        "appearance"
      ],
      "variations": [
        "tu zi",
        "tz"
      ],
      "case_sensitive": false,
      "context_notes": "Baldy - appearance-based insult",
      "target_type": "individual"
    },
    {
      "word": "矮子",
      "severity": 1,
      "categories": [
        "appearance"
      ],
      "variations": [
        "ai zi",
        "az"
      ],
      "case_sensitive": false,
      "context_notes": "Shorty - height-based insult",
      "target_type": "individual"
    },
    {
      "word": "瘦猴",
      "severity": 1,
      "categories": [
        "appearance",
        "animal_comparisons"
      ],
      "variations": [
        "shou hou",
        "sh"
      ],
      "case_sensitive": false,
      "context_notes": "Skinny monkey - body insult",
      "target_type": "individual"
    },
    {
      "word": "汉奸走狗",
      "severity": 4,
      "categories": [
        "political",
        "hate_speech"
      ],
      "variations": [
        "han jian zou gou",
        "hjzg"
      ],
      "case_sensitive": false,
      "context_notes": "Traitorous running dog - compound political insult",
      "target_type": "individual"
    },
    {
      "word": "卖国求荣",
      "severity": 4,
      "categories": [
        "political"
      ],
      "variations": [
        "mai guo qiu rong",
        "mgqr"
      ],
      "case_sensitive": false,
      "context_notes": "Sell out country for personal glory - traitor",
      "target_type": "individual"
    },
    {
      "word": "美分",
      "severity": 2,
      "categories": [
        "political",
        "internet_memes"
      ],
      "variations": [
        "mei fen",
        "mf"
      ],
      "case_sensitive": false,
      "context_notes": "American cent - pro-Western commenter accusation",
      "target_type": "individual"
    },
    {
      "word": "美狗",
      "severity": 3,
      "categories": [
        "political",
        "animal_comparisons"
      ],
      "variations": [
        "mei gou",
        "mg"
      ],
      "case_sensitive": false,
      "context_notes": "American dog - pro-US insult",
      "target_type": "individual"
    },
    {
      "word": "台独",
      "severity": 3,
      "categories": [
        "political"
      ],
      "variations": [
        "tai du",
        "td"
      ],
      "case_sensitive": false,
      "context_notes": "Taiwan independence - politically loaded term",
      "target_type": "group"
    },
    {
      "word": "港独",
      "severity": 3,
      "categories": [
        "political"
      ],
      "variations": [
        "gang du",
        "gd"
      ],
      "case_sensitive": false,
      "context_notes": "Hong Kong independence - politically loaded term",
      "target_type": "group"
    },
    {
      "word": "公知",
      "severity": 2,
      "categories": [
        "political",
        "insult"
      ],
      "variations": [
        "gong zhi",
        "gz"
      ],
      "case_sensitive": false,
      "context_notes": "Public intellectual - derogatory for liberal critics",
      "target_type": "individual"
    },
    {
      "word": "白左",
      "severity": 2,
      "categories": [
        "political",
        "insult"
      ],
      "variations": [
        "bai zuo",
        "bz"
      ],
      "case_sensitive": false,
      "context_notes": "White left - derogatory for Western liberals",
      "target_type": "group"
    },
    {
      "word": "去你妈的",
      "severity": 4,
      "categories": [
        "family_honor",
        "general"
      ],
      "variations": [
        "qu ni ma de",
        "qnmd"
      ],
      "case_sensitive": false,
      "context_notes": "Go to your mother's - dismissive curse",
      "target_type": "individual"
    },
    {
      "word": "滚你妈的蛋",
      "severity": 4,
      "categories": [
        "family_honor",
        "general"
      ],
      "variations": [
        "gun ni ma de dan",
        "gnmdd"
      ],
      "case_sensitive": false,
      "context_notes": "Roll your mother's egg - elaborate curse",
      "target_type": "individual"
    },
    {
      "word": "你算个屁",
      "severity": 2,
      "categories": [
        "insult",
        "scatological"
      ],
      "variations": [
        "ni suan ge pi",
        "nsgp"
      ],
      "case_sensitive": false,
      "context_notes": "You count as a fart - you're worthless",
      "target_type": "individual"
    },
    {
      "word": "放你妈的屁",
      "severity": 3,
      "categories": [
        "family_honor",
        "scatological"
      ],
      "variations": [
        "fang ni ma de pi",
        "fnmdp"
      ],
      "case_sensitive": false,
      "context_notes": "Fart your mother's fart - bullshit curse",
      "target_type": "individual"
    },
    {
      "word": "狗改不了吃屎",
      "severity": 3,
      "categories": [
        "animal_comparisons",
        "scatological"
      ],
      "variations": [
        "gou gai bu liao chi shi"
      ],
      "case_sensitive": false,
      "context_notes": "A dog can't stop eating shit - leopard can't change spots",
      "target_type": "individual"
    },
    {
      "word": "脑子进水",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "nao zi jin shui",
        "nzjs"
      ],
      "case_sensitive": false,
      "context_notes": "Water in the brain - stupid",
      "target_type": "individual"
    },
    {
      "word": "没脑子",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "mei nao zi",
        "mnz"
      ],
      "case_sensitive": false,
      "context_notes": "No brain - brainless",
      "target_type": "individual"
    },
    {
      "word": "吃屎去吧",
      "severity": 3,
      "categories": [
        "scatological"
      ],
      "variations": [
        "chi shi qu ba",
        "csqb"
      ],
      "case_sensitive": false,
      "context_notes": "Go eat shit",
      "target_type": "individual"
    },
    {
      "word": "见鬼去吧",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "jian gui qu ba",
        "jgqb"
      ],
      "case_sensitive": false,
      "context_notes": "Go to hell - literally 'go see ghosts'",
      "target_type": "individual"
    },
    {
      "word": "滚开",
      "severity": 2,
      "categories": [
        "general",
        "insult"
      ],
      "variations": [
        "gun kai",
        "gk"
      ],
      "case_sensitive": false,
      "context_notes": "Scram or get lost",
      "target_type": "individual"
    },
    {
      "word": "干林娘",
      "severity": 4,
      "categories": [
        "sexual",
        "family_honor"
      ],
      "variations": [
        "gan lin niang",
        "kan lim nia"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck your mother - Hokkien/Taiwan variant (kan lim nia)",
      "target_type": "individual"
    },
    {
      "word": "干你祖宗十八代",
      "severity": 4,
      "categories": [
        "sexual",
        "family_honor"
      ],
      "variations": [
        "gan ni zu zong shi ba dai"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck your ancestors eighteen generations - extreme family curse",
      "target_type": "individual"
    },
    {
      "word": "机掰",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [
        "ji bai"
      ],
      "case_sensitive": false,
      "context_notes": "Female genitalia - Taiwan vulgar term (ji-bai)",
      "target_type": "general"
    },
    {
      "word": "干你娘机掰",
      "severity": 4,
      "categories": [
        "sexual",
        "family_honor"
      ],
      "variations": [
        "gan ni niang ji bai"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck your mother's cunt - Taiwan extreme profanity",
      "target_type": "individual"
    },
    {
      "word": "靠腰",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "kao yao",
        "khau-io"
      ],
      "case_sensitive": false,
      "context_notes": "Damn - Taiwan/Hokkien expression (khau-io)",
      "target_type": "general"
    },
    {
      "word": "哩勒",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "li le",
        "li-leh"
      ],
      "case_sensitive": false,
      "context_notes": "Taiwan mild curse/exclamation (li-leh)",
      "target_type": "general"
    },
    {
      "word": "畜生不如",
      "severity": 4,
      "categories": [
        "animal_comparisons",
        "insult"
      ],
      "variations": [
        "chu sheng bu ru",
        "csbr"
      ],
      "case_sensitive": false,
      "context_notes": "Worse than an animal - extreme dehumanization",
      "target_type": "individual"
    },
    {
      "word": "下地狱",
      "severity": 3,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "xia di yu",
        "xdy"
      ],
      "case_sensitive": false,
      "context_notes": "Go to hell",
      "target_type": "individual"
    },
    {
      "word": "该死",
      "severity": 3,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "gai si",
        "gs"
      ],
      "case_sensitive": false,
      "context_notes": "Deserve to die - death curse",
      "target_type": "individual"
    },
    {
      "word": "去死吧",
      "severity": 4,
      "categories": [
        "violence",
        "threats"
      ],
      "variations": [
        "qu si ba",
        "qsb"
      ],
      "case_sensitive": false,
      "context_notes": "Go die - death wish",
      "target_type": "individual"
    },
    {
      "word": "不要脸",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "bu yao lian",
        "byl"
      ],
      "case_sensitive": false,
      "context_notes": "Shameless - face culture violation",
      "target_type": "individual"
    },
    {
      "word": "厚脸皮",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "hou lian pi",
        "hlp"
      ],
      "case_sensitive": false,
      "context_notes": "Thick-skinned - shameless",
      "target_type": "individual"
    },
    {
      "word": "不知羞耻",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "bu zhi xiu chi",
        "bzxc"
      ],
      "case_sensitive": false,
      "context_notes": "Knowing no shame",
      "target_type": "individual"
    },
    {
      "word": "臭不要脸",
      "severity": 3,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "chou bu yao lian",
        "cbyl"
      ],
      "case_sensitive": false,
      "context_notes": "Stinkingly shameless",
      "target_type": "individual"
    },
    {
      "word": "活该",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "huo gai",
        "hg"
      ],
      "case_sensitive": false,
      "context_notes": "Serves you right",
      "target_type": "individual"
    },
    {
      "word": "倒霉",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "dao mei",
        "dm"
      ],
      "case_sensitive": false,
      "context_notes": "Unlucky or bad luck",
      "target_type": "general"
    },
    {
      "word": "缺德",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "que de",
        "qd"
      ],
      "case_sensitive": false,
      "context_notes": "Immoral or wicked",
      "target_type": "individual"
    },
    {
      "word": "损",
      "severity": 1,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "sun",
        "s"
      ],
      "case_sensitive": false,
      "context_notes": "Mean or nasty",
      "target_type": "individual"
    },
    {
      "word": "恶心",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "e xin",
        "ex"
      ],
      "case_sensitive": false,
      "context_notes": "Disgusting or nauseating",
      "target_type": "general"
    },
    {
      "word": "讨厌",
      "severity": 1,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "tao yan",
        "ty"
      ],
      "case_sensitive": false,
      "context_notes": "Annoying or hateful",
      "target_type": "individual"
    },
    {
      "word": "草原",
      "severity": 2,
      "categories": [
        "internet_memes"
      ],
      "variations": [
        "cao yuan",
        "cy"
      ],
      "case_sensitive": false,
      "context_notes": "Grassland - extended euphemism for 操",
      "target_type": "general"
    },
    {
      "word": "艹你大爷",
      "severity": 3,
      "categories": [
        "sexual",
        "family_honor",
        "internet_memes"
      ],
      "variations": [
        "cao ni da ye",
        "cndy"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck your uncle - euphemistic variant",
      "target_type": "individual"
    },
    {
      "word": "法克",
      "severity": 2,
      "categories": [
        "internet_memes"
      ],
      "variations": [
        "fa ke",
        "fk"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck - Chinese phonetic transliteration",
      "target_type": "general"
    },
    {
      "word": "我屮艸芔茻",
      "severity": 2,
      "categories": [
        "internet_memes"
      ],
      "variations": [
        "wo cao cao"
      ],
      "case_sensitive": false,
      "context_notes": "Creative grass radical variations for censorship evasion",
      "target_type": "general"
    },
    {
      "word": "日",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "ri",
        "r"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck - literally 'sun/day', vulgar usage",
      "target_type": "general"
    },
    {
      "word": "日你",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "ri ni",
        "rn"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck you",
      "target_type": "individual"
    },
    {
      "word": "日本鬼子",
      "severity": 4,
      "categories": [
        "hate_speech",
        "nationality"
      ],
      "variations": [
        "ri ben gui zi",
        "rbgz"
      ],
      "case_sensitive": false,
      "context_notes": "Japanese devils - historically loaded term",
      "target_type": "group"
    },
    {
      "word": "小鬼",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "xiao gui",
        "xg"
      ],
      "case_sensitive": false,
      "context_notes": "Little devil - can refer to children or enemies",
      "target_type": "individual"
    },
    {
      "word": "死鬼",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "si gui",
        "sg"
      ],
      "case_sensitive": false,
      "context_notes": "Dead ghost - affectionate or insulting depending on context",
      "target_type": "individual"
    },
    {
      "word": "鬼佬",
      "severity": 2,
      "categories": [
        "nationality",
        "insult"
      ],
      "variations": [
        "gui lao",
        "gl"
      ],
      "case_sensitive": false,
      "context_notes": "Foreign devil - Cantonese for Westerners",
      "target_type": "group"
    },
    {
      "word": "戆鸠",
      "severity": 3,
      "categories": [
        "insult",
        "sexual"
      ],
      "variations": [
        "ngong gau"
      ],
      "case_sensitive": false,
      "context_notes": "Stupid dick - Cantonese compound insult (ngong6 gau1)",
      "target_type": "individual"
    },
    {
      "word": "戆居",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "ngong geoi"
      ],
      "case_sensitive": false,
      "context_notes": "Stupid - Cantonese (ngong6 geoi1)",
      "target_type": "individual"
    },
    {
      "word": "收皮",
      "severity": 2,
      "categories": [
        "insult",
        "general"
      ],
      "variations": [
        "shou pi",
        "sau pei"
      ],
      "case_sensitive": false,
      "context_notes": "Shut up - Cantonese dismissal (sau1 pei4)",
      "target_type": "individual"
    },
    {
      "word": "戆七",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "ngong chat"
      ],
      "case_sensitive": false,
      "context_notes": "Stupid - Cantonese variant (ngong6 chat1)",
      "target_type": "individual"
    },
    {
      "word": "死蠢",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "si chun",
        "sei ceon"
      ],
      "case_sensitive": false,
      "context_notes": "Dead stupid - Cantonese (sei2 ceon2)",
      "target_type": "individual"
    },
    {
      "word": "黐线",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "chi xian",
        "ci sin"
      ],
      "case_sensitive": false,
      "context_notes": "Crazy - Cantonese (ci1 sin3)",
      "target_type": "individual"
    },
    {
      "word": "硬膠",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "ying jiao",
        "ngaang gaau"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot - Cantonese internet slang (ngaang6 gaau1)",
      "target_type": "individual"
    },
    {
      "word": "废柴",
      "severity": 2,
      "categories": [
        "insult"
      ],
      "variations": [
        "fei chai",
        "fai caai"
      ],
      "case_sensitive": false,
      "context_notes": "Useless - literally 'waste firewood', Cantonese common (fai3 caai4)",
      "target_type": "individual"
    }
  ]
} as const

export type ZHType = typeof ZH
